export default "__VITE_ASSET__DhG_oN4c__"